import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toolbar", "checkbox", "selectAll", "count", "deleteButton"]

  connect() {
    this.updateToolbar()
  }

  toggleAll(event) {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = event.target.checked
    })
    this.updateToolbar()
  }

  toggleItem() {
    this.selectAllTarget.checked = this.checkboxTargets.every(checkbox => checkbox.checked)
    this.updateToolbar()
  }

  updateToolbar() {
    const selectedCount = this.checkboxTargets.filter(checkbox => checkbox.checked).length
    this.countTarget.textContent = `${selectedCount} selected`
    
    if (selectedCount > 0) {
      this.toolbarTarget.classList.remove('hidden')
    } else {
      this.toolbarTarget.classList.add('hidden')
    }
  }

  delete(event) {
    const selectedIds = this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.dataset.id)
    
    const form = event.target.closest('form')
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'ids[]'
    input.value = selectedIds.join(',')
    form.appendChild(input)
  }
} 